<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    d="M10.5 1C12.433 1 14 2.56701 14 4.5V14H12V15H4V14H2V4.5C2.00001 2.56701 3.56701 1.00001 5.5 1H10.5ZM5.5 2.5C4.39544 2.50001 3.50001 3.39544 3.5 4.5V12.5H12.5V4.5C12.5 3.39544 11.6046 2.5 10.5 2.5H5.5ZM11 11H8V9.5H11V11ZM10 4C10.5523 4 11 4.44772 11 5V8H5V5C5.00001 4.44773 5.44773 4.00001 6 4H10Z"
    fill="currentColor"
  />
</svg>
